import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ce317e9e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "decorate-line"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-item green"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-item yellow"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-item red"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-item blue"
}, null, -1));

const _hoisted_6 = [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5];
export default {
  __name: 'decorate-line',
  props: {
    multiple: {
      type: Number,
      default: 2
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.multiple, (_, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "all-line",
          key: index
        }, _hoisted_6);
      }), 128))]);
    };
  }

};